import { useMemo, useState } from 'react';
import { BffBrandType } from '@/types/generated';
import { ExtendedFacilities, FacilityContext, IFacilityContextProvider } from './FacilityContextProvider.ctx';
import useFacilities, { SSRFacilityContextType } from '@shared-components/services/useFacilitiesSSR';
export function FacilityContextProvider({
  brand,
  user,
  facilityCode,
  children,
  defaultToCdn = false,
  disableFacilityFetching = false,
  ssrData = null
}: Readonly<IFacilityContextProvider & {
  ssrData?: SSRFacilityContextType | null;
}>) {
  const [shouldFetchNearbyFacility, setShouldFetchNearbyFacility] = useState(!disableFacilityFetching);
  const facilities = useFacilities({
    brand,
    user,
    facilityCode,
    defaultToCdn,
    shouldFetchNearbyFacility,
    ssrData
  });

  // Extend facilities with lazy initialization support
  const extendedFacilities: ExtendedFacilities = useMemo(() => ({
    ...facilities,
    facilityCode: facilities.facilityCode,
    facilityBrand: BffBrandType.Lovet,
    shouldFetchNearbyFacility,
    initialize: () => {
      if (!shouldFetchNearbyFacility) {
        setShouldFetchNearbyFacility(true);
      }
    }
  }), [facilities, shouldFetchNearbyFacility]);
  return <FacilityContext.Provider value={extendedFacilities} data-sentry-element="FacilityContext.Provider" data-sentry-component="FacilityContextProvider" data-sentry-source-file="FacilityContextProviderSSR.ctx.tsx">{children}</FacilityContext.Provider>;
}